import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getStatistics = () => {
  return axios.get('/dashboard');
};

export const useStatistics = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['dashboard_statistics'],
    queryFn: () => getStatistics(),
  });
};
